const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard/:startDate',
  DASHBOARD_BASE: '/dashboard',
  RACECARDS: '/racecards/:startDate',
  RACECARDS_BASE: '/racecards',
  MEETINGS: ':racecourseCode',
  RACES: ':racecourseCode/:raceNumber',
  QUINTE: '/quinte/:startDate',
  QUINTE_BASE: '/quinte',
  NOT_FOUND: '/404',
  LOGIN: '/login',
  ACCOUNT: '/account',
  CGU_VALIDATION: '/cgu-validation',
  NON_RUNNERS: '/non-runners/:startDate',
  NON_RUNNERS_BASE: '/non-runners',
  RACING_EVENTS: '/racing-events/:startDate',
  PUBLICATIONS: '/publications/:startDate',
  PUBLICATIONS_BASE: '/publications',
  RACING_EVENTS_BASE: '/racing-events',
  MEETINGS_CALENDAR: '/meetings-calendar',
  PROPOSAL: '/proposal',
  FIRST_LOGIN: '/first-login',
};

export { ROUTES };
